// extracted by mini-css-extract-plugin
export var markdown = "_v9-0";
export var tableWrapper = "_v9-1";